// extracted by mini-css-extract-plugin
export default {"root":"UserAddPage_root__6IzG5","label":"UserAddPage_label__Ff4zV","errorMessage":"UserAddPage_errorMessage__v0P1y"};